import React, { useState } from "react"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule"
import {
  MITRA_ACTIVE_CONTRACT_STATUS_ENUM,
  MITRA_ACTIVE_CONTRACT_STATUS_STRING
} from "../../../../constants/StringConstant"

const SubMenuFilter = ({ onClick, initialActive }) => {
  const [subTabActive, setSubTabActive] = useState(initialActive)

  const onClickHandler = (data) => {
    setSubTabActive(data)
    onClick(MITRA_ACTIVE_CONTRACT_STATUS_ENUM[data])
  }


  return (
    <div className="bg-white px-12 pt-8 d-flex align-items-center">
      <RowModule>
        <div className="d-flex w-100 align-items-center justify-content-start" style={{ gap: 8 }}>
          {Object.keys(MITRA_ACTIVE_CONTRACT_STATUS_ENUM).map((item, i) => {
            return (
              <div key={i} className={"d-flex align-items-center"}>
                <button
                  type="button"
                  className={`btn ${
                    subTabActive === MITRA_ACTIVE_CONTRACT_STATUS_ENUM[item]
                      ? "btn-outline-primary-rounded-active"
                      : "btn-outline-default-rounded"
                  } mr-2`}
                  onClick={() => onClickHandler(MITRA_ACTIVE_CONTRACT_STATUS_ENUM[item])}>
                  {MITRA_ACTIVE_CONTRACT_STATUS_STRING[item]}
                </button>
              </div>
            )
          })}
        </div>
      </RowModule>
    </div>
  )
}

export default SubMenuFilter
